export const SUB_LINK_TYPES = {
  SYSTEM_VIEW: "system_view",
  SEGMENTS: "segments",
};

export const SELECTED_NAV_LINK_ROUTE_STORAGE_KEY = "selectedNavLinkRoute";

export const DEFAULT_HOME_PATH = "/admin";

export const SIDEBAR_WIDTH_KEY = "neeto-molecules-sidebar-width";
export const MIN_SIDEBAR_WIDTH = 12.5 * 16;
export const MAX_SIDEBAR_WIDTH = 20 * 16;
export const DEFAULT_SIDEBAR_WIDTH = 15 * 16;

export const PINNED_MORE_NAV_LINKS_KEY = "pinnedMoreNavLinks";

export const SPECIAL_APP_NAMES = { bugwatch: "BugWatch" };
